<template>
    <Button @click.prevent="onBoxCreateClick" :empty="empty">
        <template>
            {{ Translations.buttons.createBox }}
        </template>
    </Button>
</template>
<script>
    import EventBus from '@/eventbus';
    import Button from '@/components/common/Button.vue'
    import Translations from '@/store/translations'
    export default {
        name: "BoxCreationButton",
        extends: Button,
        methods: {
            onBoxCreateClick: () => { EventBus.$emit('onBoxCreation'); },
        },
        computed: {
            Translations : () => { return Translations; }
        }
    }
</script>
<style scoped>
</style>
